import React from "react";

import { motion } from "framer-motion";

import { ArrowUpRight, CalendarDays } from "lucide-react";

import { useNavigate } from "react-router-dom";

const BlogCard = ({ blog, index }) => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{
        duration: 0.5,
        delay: index * 0.08,
      }}
      onClick={() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });

        navigate(`/blogs/${blog.slug}`);
      }}
      className="
        group
        cursor-pointer
        overflow-hidden
        rounded-2xl
        border
        theme-border
        theme-card
        transition-all
        duration-500
        hover:-translate-y-2
        hover:border-primaryColor
        hover:shadow-[0_15px_40px_rgba(255,140,0,.18)]
      "
    >
      {/* ============================================================
          IMAGE
      ============================================================ */}
      <div className="overflow-hidden">
        <motion.img
          src={blog.image}
          alt={blog.title}
          whileHover={{ scale: 1.08 }}
          transition={{ duration: 0.5 }}
          className="
            h-44
            w-full
            object-cover
            sm:h-48
            md:h-52
            lg:h-52
            xl:h-56
          "
        />
      </div>

      {/* ============================================================
          CONTENT
      ============================================================ */}
      <div className="p-4 sm:p-5">

        {/* ========================================================
            CATEGORY
        ======================================================== */}
        <span
          className="
            inline-flex
            items-center
            rounded-full
            border
            border-primaryColor/30
            bg-primaryColor/10
            px-3
            py-1
            text-[9px]
            font-semibold
            uppercase
            tracking-[0.18em]
            text-primaryColor
            sm:text-[10px]
          "
        >
          {blog.category}
        </span>

        {/* ========================================================
            TITLE
        ======================================================== */}
        <h3
          className="
            mt-3
            line-clamp-2
            text-lg
            font-semibold
            leading-7
            theme-text-primary
            transition-colors
            duration-300
            group-hover:text-primaryColor
            sm:text-xl
          "
        >
          {blog.title}
        </h3>

        {/* ========================================================
            DESCRIPTION
        ======================================================== */}
        <p
          className="
            mt-2
            line-clamp-3
            text-sm
            leading-6
            theme-text-muted
          "
        >
          {blog.description}
        </p>

        {/* ========================================================
            FOOTER
        ======================================================== */}
        <div
          className="
            mt-4
            flex
            items-center
            justify-between
            border-t
            theme-border
            pt-4
          "
        >
          {/* DATE */}
          <div
            className="
              flex
              items-center
              gap-2
              text-xs
              theme-text-muted
            "
          >
            <CalendarDays size={14} />

            <span>{blog.date}</span>
          </div>

          {/* READ MORE */}
          <div
            className="
              flex
              items-center
              gap-2
              text-sm
              font-semibold
              text-primaryColor
              transition-all
              duration-300
              group-hover:gap-3
            "
          >
            <span>Read More</span>

            <ArrowUpRight
              size={16}
              className="
                transition-transform
                duration-300
                group-hover:rotate-45
              "
            />
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default BlogCard;